import React from "react";
import styles from "./styles/Spacer.module.css";
import View from "../View";

export default function Spacer(props) {
  return (
    <View className={`${styles.defaults} ${props.className} ${props.size === "small" ? styles.small : ''} ${props.size === "medium" ? styles.medium : ''} ${props.size === "large" ? styles.large : ''} ${props.style}`}>{props.children}</View>
  );
}
